<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>商品管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/seriesManagement')">系列管理</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='系列名称'>
            <el-input
              clearable
              style="width:500px"
              v-model="filters.keyword"
              placeholder="请输入系列名称搜索"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="状态">
            <el-select
              v-model="filters.status"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="可用"
                value="1"
              ></el-option>
              <el-option
                label="禁用"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--
          <el-form-item
            label="创建时间"
          >
              <el-form-item prop="startTime">
                <el-date-picker
                  type="date"
                  placeholder="选择开始日期"
                  v-model="filters.startTime"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
              <span style="display: inline-block;margin-right: 9px;">-</span>
              <el-form-item prop="endTime">
                <el-date-picker
                  type="date"
                  placeholder="选择结束日期"
                  v-model="filters.endTime"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>

          </el-form-item> -->
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button v-if="hasPower('30082991')"
              type="success"
              @click="addPostDialog"
            >新增</el-button>
            <!-- <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出sku销量</el-button> -->
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="id"
            label="编号"
          >
          </el-table-column>
          <el-table-column
            label="系列名称"
            prop="typeName"
          >
          </el-table-column>

          <el-table-column
            prop="status"
            label="状态"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.status == 1"
                type="success"
                disable-transitions
              >可用</el-tag>
              <el-tag
                v-if="scope.row.status == 2"
                type="warn"
                disable-transitions
              >禁用</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="时间"
          >
          </el-table-column>

          <el-table-column
            prop="type"
            label="分类"
          >
          </el-table-column>

          <el-table-column
            label="操作"
            width="180"
          >
            <template slot-scope="scope">
              <el-button v-if="hasPower('30082991')"
                @click="editPostDialog(scope.row)"
                type="text"
                size="small"
              >编辑</el-button>
              <el-button v-if="hasPower('30082991') && scope.row.status == 2"
                @click="upHouseStatus(scope.row, 1)"
                type="text"
                size="small"
              >启用</el-button>
              <el-button v-if="hasPower('30082991') && scope.row.status == 1"
                @click="upHouseStatus(scope.row,2)"
                type="text"
                size="small"
              >禁用</el-button>
              <el-button v-if="hasPower('30082991')"
                @click="upHouseStatus(scope.row, 3)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import {dateFunc} from "../../dateFunc";
export default {
  name: "goodList",
  created() {},

  data() {
    return {
      addFormRule: {
        property: [
          { required: true, message: "请输入商品名称", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选择上架状态", trigger: "blur" }]
      },
      addLoading: false,
      loading: false,
      form: {
        status: null,
        property: null,
        id: null
      },
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      filters: {
        suType:null,
        index_status:null,
        startTime: null,
        endTime: null,
        special_type:null,
        status: null,
        noVip:null,
        first_type_id: null,
        keyword: null,
        pid: null
      },
      isCollapse: true,
      activeName: "second",
      dialogAddVisible: false,
      backFirst: 1,
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      specialOptions: [{ title: "不可以购买", id: "1" }, { title: "可以购买", id: "2" }],
      options: [{ text: "待上架", value: "1" }, { text: "上架", value: "2" }],
      typeOptions: null,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    let that = this;
    let params = {
      pageNum: 1,
      pageSize: 100,
      infoType:1,
      token: localStorage.getItem("api_token")
    };
    that.loading = true;
    API.good_first_type_list(params)
      .then(
        function(result) {
          that.loading = false;
          if (result.key == 1000) {
            that.typeOptions = [];
            for (var i=0; i<result.result.list.length; i++) {
              if (result.result.list[i].title != '全部') {
                that.typeOptions.push(result.result.list[i]);
              }
            }
          }
        },
        function(err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    this.handleSearch();
  },
  methods: {
    excelOut() {
      var that = this;

      var url =
        "/manager/user/pc/sku_excel?token=" + localStorage.getItem("api_token");
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      }
      if (that.filters.first_type_id) {
        url = url + "&first_type_id=" + that.filters.first_type_id;
      }
      if (that.filters.keyword) {
        url = url + "&keyword=" + that.filters.keyword;
      }
      if (that.filters.startTime) {
        url = url + "&startDate=" + that.filters.startTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: "请选择时间段",
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endDate=" + that.filters.endTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: "请选择时间段",
          duration: 2000
        });
        return;
      }
      top.location.href = url;
    },
    showSecond(row) {
      this.$router.push({
        path: "/goodPropertyList",
        query: {
          goodId: row.id,
          goodName: row.good_name
        }
      });
    },
    showPostage(row) {
      this.$router.push({
        path: "/goodPostageList",
        query: {
          goodId: row.id,
          goodName: row.good_name
        }
      });
    },
    showSku(row) {
      this.$router.push({
        path: "/skuList",
        query: {
          goodId: row.id,
          goodName: row.good_name
        }
      });
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    addPostDialog() {
      this.$router.push({
        path: "/add_seriesManagement"
      });
    },
    editPostDialog(row) {
      this.$router.push({
        path: "/add_seriesManagement",
        query: {
          good: row
        }
      });
    },

    upIndexStatus(row, status, typeId) {
      let that = this;
      var m1 = "";
      var m2 = "";
      var m3 = "";
      var type = "";
      if (status == 2) {
        m1 = "确定取消推荐该商品吗？";
        m2 = "取消成功后，app首页就不显示该商品";
        m3 = "取消成功";
        type = "warning";
      } else if (status == 1) {
        m1 = "确定推荐该商品吗？";
        m2 = "成功后，app首页就会显示该商品";
        m3 = "推荐成功";
        type = "success";
      }
      this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
            status: status,
            typeId: typeId
          };
          API.status_index_good(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    upHouseStatus(row, status) {
      let that = this;
      var m1 = "";
      var m3 = "";
      var type = "";
      if (status == 1) {
        m1 = "确定启用该系列吗？";
        m3 = "启用成功";
        type = "success";
      } else if (status == 2) {
        m1 = "确定禁用该系列吗？";
        m3 = "禁用成功";
        type = "warning";
      } else {
        m1 = "确定删除该系列吗？";
        m3 = "删除成功";
        type = "error";
      }
      this.$confirm(m1, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
            status: status
          };
          API.status_good_series(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (para.status == 3) {
                  }
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                }  else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.status) {
        params.status = that.filters.status;
      }

      if (
        that.filters.keyword &&
        that.filters.keyword != null &&
        that.filters.keyword != ""
      ) {
        params.keyword = that.filters.keyword;
      }
      that.loading = true;
      API.good_series_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  if (result.result.list[i].createTime != null) {
                    result.result.list[i].createTime = dateFunc.formatDate(
                      new Date(parseInt(result.result.list[i].createTime)),
                      "yyyy-MM-dd hh:mm:ss"
                    );
                  }
                }
                result.result.list.forEach( item => {
                  item.type = ''
                  JSON.parse(item.typeId).forEach( items => {
                    item.type += items.name + ", "
                  })
                  item.type = item.type.substr(0, item.type.length - 2);
                })
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/good/seriesManagement.vue